import { configureStore } from "@reduxjs/toolkit";
import stationsReducer from "./features/stations/stationsSlice";

export const store = configureStore({
  reducer: {
    stations: stationsReducer,
  },
});
